module.exports = __webpack_public_path__ + "img/guanzhu.0f2497ba.png";